<template>
  <i :class="['material-icons', size, color, alignment]" @click="$emit('click')">{{ iconName }}</i>
</template>

<script>
export default {
  name: "IconDefault",
  props: {
    icon: {
      type: String,
      required: true
    },
    size: {
      type: String
    },
    color: {
      type: String
    },
    alignment: {
      type: String
    }
  },
  computed: {
    iconName() {

      /*
       * This maps icon names we use to the names used by the icon library
       *
       * Please list all icons alphabetically to make it easier to find
       */
      switch (this.icon) {
        case 'addressed': return 'mark_chat_read';
        case 'alarm': return 'alarm';
        case 'appointment': return 'calendar_today';
        case 'appointments': return 'calendar_month';
        case 'appointment_assigned': return 'perm_contact_calendar';
        case 'assigned_leads': return 'add_home';
        case 'attach': return 'add_link';
        case 'automation': return 'settings_suggest';
        case 'automations': return 'settings_suggest';
        case 'calendar_available': return 'event_available'
        case 'call': return 'phone';
        case 'call-hangup': return 'call_end';
        case 'call-missed': return 'phone_missed';
        case 'call-mute': return 'volume_off';
        case 'call-unmute': return 'volume_up';
        case 'call-scripts': return 'content_paste';
        case 'campaign': return 'campaign';
        case 'campaign-bandit-signs': return 'follow_the_signs';
        case 'campaign-billboards': return 'follow_the_signs';
        case 'campaign-classifieds': return 'receipt';
        case 'campaign-cold-calling': return 'phone';
        case 'campaign-direct-mail': return 'markunread_mailbox';
        case 'campaign-door-knocking': return 'sensor_door';
        case 'campaign-facebook': return 'facebook';
        case 'campaign-google-ads': return 'follow_the_signs';
        case 'campaign-mls': return 'list';
        case 'campaign-organic': return 'web';
        case 'campaign-other': return 'follow_the_signs';
        case 'campaign-radio': return 'radio';
        case 'campaign-referrals': return 'face';
        case 'campaign-ringless-voicemail': return 'voicemail';
        case 'campaign-texting': return 'chat';
        case 'campaign-tv': return 'tv';
        case 'campaign-website': return 'desktop_mac';
        case 'change-negative': return 'arrow_downward';
        case 'change-positive': return 'arrow_upward';
        case 'check': return 'done';
        case 'checkbox': return 'check_box';
        case 'checkbox-blank': return 'check_box_outline_blank';
        case 'close': return 'close';
        case 'collapse': return 'expand_less';
        case 'collapseToggle': return 'expand_more';
        case 'comms': return 'forum';
        case 'contacts': return 'people';
        case 'copy': return 'content_copy';
        case 'deal-probability': return 'speed';
        case 'down': return 'expand_more';
        case 'dropdown': return 'arrow_drop_down';
        case 'delete': return 'delete';
        case 'edit': return 'edit';
        case 'email': return 'mail';
        case 'error': return 'error';
        case 'expand': return 'expand_more';
        case 'external_link': return 'open_in_new';
        case 'filter': return 'filter_alt';
        case 'follow-up': return 'record_voice_over';
        case 'follow-up-active': return 'hourglass_empty';
        case 'follow-up-complete': return 'done';
        case 'follow-up-pause': return 'pause';
        case 'follow-up-cancel': return 'highlight_off';
        case 'google-drive': return 'add_to_drive';
        case 'help': return 'help';
        case 'import': return 'file_upload';
        case 'inbox': return 'inbox';
        case 'info': return 'info';
        case 'integration': return 'settings_input_composite';
        case 'lead': return 'home';
        case 'left': return 'chevron_left';
        case 'link': return 'link';
        case 'list': return 'list';
        case 'menu': return 'more_horiz';
        case 'mention': return 'alternate_email';
        case 'note': return 'push_pin';
        case 'notifications': return 'notifications';
        case 'past-due': return 'event_busy';
        case 'pipeline': return 'dashboard';
        case 'play': return 'play_arrow';
        case 'plus': return 'add';
        case 'recent-leads': return 'history';
        case 'refresh': return 'sync';
        case 'remove': return 'remove_circle_outline';
        case 'right': return 'chevron_right';
        case 'search': return 'search';
        case 'selected': return 'task_alt';
        case 'send': return 'send';
        case 'settings': return 'settings';
        case 'sms': return 'textsms';
        case 'snippets': return 'assignment';
        case 'sort': return 'unfold_more';
        case 'stats': return 'bar_chart';
        case 'store': return 'storefront';
        case 'task': return 'done';
        case 'temperature': return 'thermostat';
        case 'text': return 'chat_bubble';
        case 'today': return 'today';
        case 'up': return 'expand_less';
        case 'upcoming': return 'date_range';
        case 'upgrade': return 'upgrade';
        case 'upload': return 'upload';
        case 'up-next': return 'done_all';
        case 'user-dashboard': return 'checklist';
        case 'users': return 'supervisor_account';
        case 'warning': return 'warning';
        case 'webhook': return 'link';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

/*
 * Sizes
 */
.material-icons {
  // default is 24px

  &.is-small {
    font-size: 16px!important;
  }
  &.is-large {
    font-size: 32px!important;
  }
}

/*
 * Colors
 */
.material-icons {
  // default is $text

  &.is-primary {
    color: $primary;
  }

  &.is-blue,
  &.is-secondary {
    color: $secondary;
  }

  &.is-link {
    color: $primary;
  }

  &.is-success {
    color: $green;
  }

  &.is-warning {
    color: $yellow;
  }

  &.is-danger {
    color: $red;
  }

  &.is-light {
    color: $text-light;
  }

  &.is-white {
    color: $white;
  }

  &.is-call {
    color: $calls;
  }

  &.is-text {
    color: $texts;
  }

  &.is-email {
    color: $emails;
  }

  &.is-note {
    color: $notes;
  }

  &.bottom {
    vertical-align: bottom;
  }
}
</style>
